import React, { useEffect, useState, useRef, useCallback } from "react";
import { Typography } from "@mui/material";
import Ask from "src/Assets/images/ask.svg";
import upArrow from "src/Assets/images/UpButton.png";
import "./AsksActivity.css";
import ActivityPost from "../../ActivityPost";
import API from "../../../../network";
import CircularProgress from "@material-ui/core/CircularProgress";
// import ConfirmationDialog from "src/Components/ConfirmationDialog";

function AsksActtivity(props) {
  const {
    activityCountRes,
    decreaseActivityAskCount,
    onHashTagClick,
    isCountLoading,
  } = props;
  const [isListOpen, setisListOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [completeAskListData, setCompleteAskListData] = useState({});
  const [breadCountLength, setBreadCountLength] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const listRef = useRef(null);
  const [confModalVisible, setConfModalVisible] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [activityLoading, setActivityLoading] = useState(false);

  const toggleList = () => {
    setisListOpen(true);
  };
  const handleScroll = useCallback(() => {
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5 && hasMore) {
      setPageNumber((prevPageNumber) => prevPageNumber + 1);
    }
  }, [hasMore]);

  // const getData = (page) => {
  //   API.getUserAsks(breadCountLength, page).then((res) => {
  //     setListData((prevList) => [...prevList, ...res.data.askList]);
  //     setCompleteAskListData(res.data);
  //     setBreadCountLength(
  //       (prevBreadLength) => prevBreadLength + res.data.askList.length
  //     );
  //   });
  // };

  const getData = async (page) => {
    try {
      if (page === 1) {
        setListData([]);
      }
      const newPage = (page - 1) * 10;
      setActivityLoading(true);
      const res = await API.getUserAsks(newPage);

      const askList = res?.data?.askList || [];

      if (askList.length > 0) {
        setListData((prevList) => [...prevList, ...askList]);
        setBreadCountLength(
          (prevBreadLength) => prevBreadLength + askList.length
        );
        setHasMore(true);
      } else {
        setHasMore(false);
      }

      setCompleteAskListData(res.data || {});
    } catch (error) {
      console.error("Error fetching user asks:", error);
      alert("Failed to load data. Please try again later.");
      setHasMore(false);
    } finally{
      setActivityLoading(false);
    }
  };

  useEffect(() => {
    if (isCountLoading) return;
    getData(pageNumber);
  }, [isCountLoading, pageNumber]);

  const updateParentComponentSayCount = (parentId, operator, filterType) => {
    const newListData = listData.map((item) => {
      if (item.id === parentId) {
        const key = filterType === "activityTag" ? "postCount" : "sayCount";
        const count = item[key] || 0;

        return {
          ...item,
          [key]: operator === "increment" ? count + 1 : Math.max(0, count - 1),
        };
      }
      return item;
    });

    setListData(newListData);
  };

  const decreaseAskListCount = () => {
    setCompleteAskListData((prevData) => ({
      ...prevData,
      askListSize: prevData.askListSize - 1,
    }));
  };

  const updateList = (id, followStatus) => {
    const newData = [...listData];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.followStatus = followStatus.includes("0")
      ? "inactive"
      : "Active";
    modifiedData.followCount = followStatus.includes("0")
      ? modifiedData.followCount - 1
      : modifiedData.followCount - 1 + 2;
    setListData(newData);
  };

  const onClose = () => {
    setConfModalVisible(null);
  };

  const confirmationForDelete = (id) => {
    setConfModalVisible({
      open: true,
      // type: "warning",
      title: "Are you sure you want to delete this ASK?",
      rejectLabel: "Cancel",
      acceptLabel: "Yes",
      onReject: onClose,
      onAccept: () => deleteAsk(id),
    });
  };

  const deleteActivityAskPost = (id) => {
    const newData = [...listData];
    const modifiedData = newData.filter((x) => x.id !== id);
    setListData(modifiedData);
  };

  const deleteAsk = (id) => {
    let formdata = new FormData();
    formdata.append("messageID", id);
    API.deleteProfilePost(formdata)
      .then((res) => {
        const newList = [...listData];
        const index = newList.findIndex((x) => x.id === id);
        if (index > -1) {
          newList.splice(index, 1);
          setListData(newList);
          decreaseAskListCount();
          decreaseActivityAskCount && decreaseActivityAskCount();
        }
        setConfModalVisible(null);
      })
      .catch((err) => {});
  };

  const updateMessage = useCallback((id, message, locationName, attachment, lat, lng) => {
    const tempUrl =
      attachment instanceof File ? URL.createObjectURL(attachment) : null;
    const urlRegex =
      /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
    const extractedUrls = message ? message.match(urlRegex) || [] : [];

    setListData((prevList) =>
      prevList.map((eachItem) => {
        if (eachItem?.id === id) {
          const { newSelectedLocation, ...cleanItem } = eachItem;
          const cleanUpdatedMsg = (message || "").replace(/<[^>]+>/g, "").trim();
          const cleanDefaultMsg = (eachItem?.Message || "").replace(/<[^>]+>/g, "").trim();
          const isTextModified = cleanUpdatedMsg.length > 0 && cleanUpdatedMsg !== cleanDefaultMsg;
          const isAttachmentAdded = attachment instanceof File;
          const isContentEdited = isTextModified || isAttachmentAdded;

          return {
            ...cleanItem,
            Message: message,
            msg: message,
            url: extractedUrls.length > 0 ? extractedUrls : eachItem?.url,
            locName: locationName || "",
            msgLat: locationName ? (lat || eachItem.msgLat || "") : "",
            msgLng: locationName ? (lng || eachItem.msgLng || "") : "",
            docName:
              attachment?.name ||
              (attachment === null ? "" : eachItem.docName || ""),
            docLocation:
              tempUrl ||
              (attachment === null ? "" : eachItem.docLocation || ""),
            docTagged:
              attachment ? 1 : attachment === null ? 0 : eachItem.docTagged,
            ...(isContentEdited ? { updated_time: "1m", edited: 1 } : {}),
          };
        }
        return { ...eachItem };
      })
    );
  }, []);

  useEffect(() => {
    const handlePostUpdated = (event) => {
      const { id, message, locationName, attachment, lat, lng } = event.detail || {};
      if (id) {
        updateMessage(id, message, locationName, attachment, lat, lng);
      }
    };
    window.addEventListener("postUpdated", handlePostUpdated);
    return () => {
      window.removeEventListener("postUpdated", handlePostUpdated);
    };
  }, [updateMessage]);

    // const newData = [...listData];
    // const modifiedData = newData.find((x) => x.id === id);
    // modifiedData.Message = message;
    // let formdata = new FormData();
    // formdata.append("messageID", id);
    // formdata.append("message", message);
    // API.updateProfilePost(modifiedData.locName, formdata)
    //   .then((res) => {
    //     setListData(newData);
    //   })
    //   .catch((err) => {});

  const handleDeleteAttachementDocFromParent = (id) => {
    setListData((prevData) =>
      prevData.map((item) =>
        item.id === id
          ? { ...item, docName: null, docLocation: null, docTagged: 0 }
          : item
      )
    );
  };

  const updateIsOpeASkStatus = (id) => {
    setListData((prevData) =>
      prevData.map((item) =>
        item.id === id
          ? { ...item, isOpeASk: "1"}
          : item
      )
    );
  }

  return (
    <>
      {!isListOpen && (
        <div className="AskActivity" onClick={toggleList}>
          <div className="usable-container">
            <img src={Ask} alt="Ask-icon" className="askicon" />
            <Typography className="ask">ASK</Typography>
          </div>
          {/* Activity Data */}
          <div className="usable-container">
            <span className="number ">
              {activityCountRes.allasksactivitycount}
            </span>
            <img src={upArrow} alt="DownArrow" className="DownArrow" />
          </div>
        </div>
      )}

      {isListOpen && (
        <div className="AskActivity_active">
          {/* Activity Name */}
          <div
            className="color-combination"
            onClick={() => setisListOpen(false)}
          >
            <div className="usable-container">
              <img src={Ask} alt="Ask-icon" className="askicon" />
              <Typography className="ask">ASK</Typography>
            </div>
            {/* Activity Data */}
            <div className="usable-container">
              <span className="number ">
                {activityCountRes.allasksactivitycount}
              </span>
              <img src={upArrow} alt="DownArrow" className="DownArrow" />
            </div>
          </div>
          {/* Post Data */}
          {/* {isListOpen && ( */}
          <div
            ref={listRef}
            onScroll={handleScroll}
            role="list"
            className="posts"
          >
            {listData && listData.length !== 0 ? (
              <ActivityPost
                listData={listData}
                updateParentComponentSayCount={updateParentComponentSayCount}
                updateList={updateList}
                delete={confirmationForDelete}
                updateMessage={updateMessage}
                pageNumber={pageNumber}
                filterType="activityAsk"
                onHashTagClick={onHashTagClick}
                decreaseActivityAskCount={decreaseActivityAskCount}
                deleteActivityAskPost={deleteActivityAskPost}
                setPageNumber={setPageNumber}
                getData={getData}
                onDelete={deleteAsk}
                postType={"ASK"}
                handleDeleteAttachementDocFromParent={
                  handleDeleteAttachementDocFromParent
                }
                updateIsOpeASkStatus={updateIsOpeASkStatus}
              />
            ) : (
              <div className="no-data-container">
                {activityLoading ? (
                  <CircularProgress size={25} />
                ) : (
                  <p>No Activity Asks found</p>
                )}
              </div>
            )}
          </div>
          {/* )} */}
        </div>
      )}
      {/* {confModalVisible?.open && <ConfirmationDialog {...confModalVisible} />} */}
    </>
  );
}

export default AsksActtivity;
